function waitForTapcart(maxWaitTimeMs = 10000, checkIntervalMs = 100) {
  let interval, timeout;

  return new Promise((resolve, reject) => {
    const cleanup = () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };

    timeout = setTimeout(() => {
      cleanup();
      reject(new Error("Tapcart not initialized within time limit"));
    }, maxWaitTimeMs);

    interval = setInterval(() => {
      if (window.Tapcart?.isInitialized) {
        cleanup();
        resolve(window.Tapcart);
      }
    }, checkIntervalMs);
  });
}

function initAddToCartAction(tapcartObject) {
  document.addEventListener("product-ajax:added", ({ detail: response }) => {
    if (!response || !response.product) return;

    const product = response.product;

    const attributes = product.properties
      ? Object.entries(product.properties)
        .filter(([key, value]) => key && value)
        .map(([key, value]) => ({ key, value }))
      : [];

    const lineItem = {
      variantId: product.variant_id,
      quantity: product.quantity,
      ...(attributes.length > 0 && {
        attributes
      })
    };

    tapcartObject.action("cart/add", {
      lineItems: [
        lineItem
      ]
    });

    tapcartObject.action("screen/open", {
      "destination": {
        "type": "route",
        "id": "cart"
      }
    });
  });
}

async function initRedirectToProductPage(tapcartObject) {
  const vault = await tapcartObject.actions.vault.initialize("productDetails", "global");
  vault.get("productData")
    .then(value => {
      const { variant, title, productId, handle } = value || {};

      if (!handle || !variant) {
        return;
      }

      window.location.href = `${Shopify.routes.root}products/${handle}${variant ? `?variant=${variant}` : ''}`;
    })
    .catch(error => console.error(error));
}

document.addEventListener("DOMContentLoaded", () => {
  waitForTapcart()
    .then((tapcartObject) => {
      if (!tapcartObject) {
        return;
      }

      initRedirectToProductPage(tapcartObject);
      initAddToCartAction(tapcartObject);
    })
    .catch(error => console.error(error.message));
});

initAddToCartAction();
